import React from 'react';
import { useNavigate, useCallback } from 'hooks';
import { Typography, useTheme } from '@mui/material';
import { tokens } from 'theme';
import { MenuItem } from 'react-pro-sidebar';
import { SidebarItemType } from '../types/sidebar-item.type';

export const SidebarItem: React.FC<SidebarItemType> = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const onClickHandler = useCallback(() => {
    setSelected(title);
    navigate(to);
  }, [navigate, setSelected, title, to]);
  const isActive = selected === title;

  return (
    <MenuItem
      style={{
        color: colors.grey[100],
        backgroundColor: isActive && colors.primary[400],
      }}
      onClick={onClickHandler}
      icon={icon}
    >
      <Typography>{title}</Typography>
    </MenuItem>
  );
};
